<!--CMS HTML CONTENT-->
<!--HEADING-->
<h2 class="text-align-left" *ngIf="title">{{ title | decodeEntities }}</h2>
<!--END HEADING-->
<div class="htmlresponse margin-top-small" #htmlResponse [innerHTML]="bodyContent"></div>
<!--END CMS HTML CONTENT-->
